export default __webpack_public_path__ + "static/media/about_us_img.2316abf9.png";